import * as React from "react";
import {
  TagDropdownItem,
  TagDropdownNav,
  TagDropdownToggle,
  TagDropdownWrapper,
  IconChevron,
} from "atoms";

const sortOptions = {
  upvotes: "Most Helpful",
  "created desc": "Newest",
  created: "Oldest",
};

type ReviewSortOption = keyof typeof sortOptions;

interface ReviewSortProps {
  activeOption: ReviewSortOption;
  createHandler: (option: ReviewSortOption) => VoidFunction;
  isModerationPage?: boolean;
}

const useReviewSort = (defaultOption?: ReviewSortOption) => {
  const [activeReviewSort, setActiveReviewSort] =
    React.useState<ReviewSortOption>(defaultOption ?? "upvotes");

  const createReviewSortHandler = (option: ReviewSortOption) => () => {
    setActiveReviewSort(option);
  };

  return { activeReviewSort, createReviewSortHandler };
};

function ReviewSort({
  activeOption,
  createHandler,
  isModerationPage = false,
}: ReviewSortProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => setIsOpen(!isOpen);

  // If user selects menu option, the menu should close after event bubbles up
  const close: React.ReactEventHandler = (event) => {
    if (event.currentTarget !== event.target) {
      setIsOpen(false);
    }
  };

  return (
    <TagDropdownWrapper>
      <TagDropdownToggle
        onClick={toggle}
        isOpen={isOpen}
        aria-expanded={isOpen}
      >
        Sort&nbsp;By
        <IconChevron />
      </TagDropdownToggle>

      {isOpen && (
        <TagDropdownNav onClick={close} duration={300}>
          <ul>
            {Object.entries(sortOptions)
              .filter((entry) => !(isModerationPage && entry[0] === "upvotes"))
              .map(([option, label]) => (
                <li key={option}>
                  <TagDropdownItem
                    variant="blank"
                    onClick={createHandler(option as ReviewSortOption)}
                    isActive={option === activeOption}
                  >
                    {label}
                  </TagDropdownItem>
                </li>
              ))}
          </ul>
        </TagDropdownNav>
      )}
    </TagDropdownWrapper>
  );
}

export type { ReviewSortOption };
export { ReviewSort, useReviewSort };
